// File: src/components/EditTestModal.jsx
import React, { useEffect, useState } from "react";
import { updateTestById } from "../api";

export default function EditTestModal({ test, onClose, onSaved }) {
  const [title, setTitle] = useState(test?.title || "");
  const [isPublic, setIsPublic] = useState(!!test?.isPublic);
  const [sharedText, setSharedText] = useState(
    (test?.sharedWith || []).join(", ")
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setTitle(test?.title || "");
    setIsPublic(!!test?.isPublic);
    setSharedText((test?.sharedWith || []).join(", "));
  }, [test]);

  async function handleSave() {
    setError("");
    if (!title.trim()) {
      setError("Title cannot be empty");
      return;
    }
    setSaving(true);
    try {
      const sharedArr = (sharedText || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const payload = {
        title: title.trim(),
        isPublic: !!isPublic,
        sharedWith: sharedArr,
      };
      await updateTestById(test.id, payload);
      setSaving(false);
      onSaved && onSaved({ ...test, ...payload });
      onClose && onClose();
    } catch (e) {
      console.error("Update failed", e);
      setError("Failed to save. Try again.");
      setSaving(false);
    }
  }

  if (!test) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg">
        <h3 className="text-xl font-semibold mb-4">Edit Test</h3>

        <label className="block mb-2 text-sm">
          Title
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border rounded p-2 mt-1"
          />
        </label>

        <label className="block mb-2 text-sm">
          Visibility
          <div className="flex gap-3 mt-1">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                checked={!isPublic}
                onChange={() => setIsPublic(false)}
              />
              Private
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                checked={isPublic}
                onChange={() => setIsPublic(true)}
              />
              Public
            </label>
          </div>
        </label>

        <label className="block mb-2 text-sm">
          Shared with (comma separated UIDs or emails)
          <input
            value={sharedText}
            onChange={(e) => setSharedText(e.target.value)}
            className="w-full border rounded p-2 mt-1"
            placeholder="uid1@example.com, uid2, user3@example.com"
          />
        </label>

        {error && <div className="text-sm text-red-600 mb-2">{error}</div>}

        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={() => onClose && onClose()}
            className="px-4 py-2 rounded border"
            disabled={saving}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 rounded bg-green-600 text-white"
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
